import { useTransactionIdentifierWithReceipt } from "@/common/hooks/queries/useTransactionIdentifierWithReceipt";
import usePrint from "@/common/hooks/usePrint";
import { PrinterIcon } from "lucide-react";
import { useState } from "react";
import PrintContext from "../PrintContext";
import Modal from "../Modal";
import Button from "../Button";
import { ModalMessageSimple } from "../ModalMessageSimple";

interface PrintReceiptButton {
  eventId?: string;
  showConfirmationModal?: boolean;
  disabled?: boolean;
}

const PrintReceiptButton = ({ eventId, showConfirmationModal, disabled }: PrintReceiptButton) => {
  const [confirmationModalIsOpen, setConfirmationModalIsOpen] = useState(false)
  const [messages, setMessages] = useState<string[] | boolean>(false)

  const { print, contextProps } = usePrint({});

  const {
    mutate: getTransactionIdentifier,
    isPending: isGetTransactionIdentifierPending,
  } = useTransactionIdentifierWithReceipt({
    transactionIdentifierId: eventId,
    onSuccess: (data) => {
      setConfirmationModalIsOpen(false);
      const receipt = data.eventable.receipt.text;

      if (receipt) {
        print({ content: receipt });
      } else {
        setMessages(['Ocorreu um erro ao buscar as informações do comprovante'])
      }
    },
    onError: (error) => {
      setConfirmationModalIsOpen(false);
      setMessages(error.response?.data.errors.base || ['Ocorreu um erro ao buscar as informações do comprovante'])
    },
  })

  const handleClick = () => {
    if (showConfirmationModal) {
      setConfirmationModalIsOpen(true);
    } else {
      getTransactionIdentifier();
    }
  };

  return (
    <>
      <Button
        className="bg-transparent hover:bg-transparent disabled:hover:bg-transparent p-0 mx-auto"
        onClick={handleClick}
        disabled={disabled || isGetTransactionIdentifierPending}
        isLoading={isGetTransactionIdentifierPending}
        operationKlassToCheckPermission="Establishment::Billing::TransactionIdentifiers::ShowWithReceipt"
      >
        <PrinterIcon strokeWidth={1} />
      </Button>

      {showConfirmationModal && (
        <Modal
          isOpen={confirmationModalIsOpen}
          setIsOpen={setConfirmationModalIsOpen}
          showClose={false}
          title="Reimprimir comprovante"
          subtitle="Deseja prosseguir com a reimpressão do comprovante para manter uma cópia adicional desta operação?"
          titleClass="text-2xl"
          subtitleClassName="mt-1 text-white-400 text-md"
          useCancellableFooter
          cancelButtonClassName="bg-white-100 rounded-es-lg"
          confirmButtonClassName="bg-blue-700 rounded-ee-lg"
          onConfirm={() => getTransactionIdentifier()}
        />
      )}

      <PrintContext {...contextProps} className="text-black-900 px-1" />

      {messages && (
        <ModalMessageSimple
          messages={messages}
          setMessages={setMessages}
          isError
        />
      )}
    </>
  )
}

export default PrintReceiptButton;
